import React from "react";
import MetaTags from "react-meta-tags";

export const SITE_ORIGIN = "https://handcombos.com";

// Per-route head tags. index.html can only carry one canonical for the whole
// SPA, which would point every route at the homepage, so canonical lives here.
export default function SeoMetaTags(props) {
  const { title, description, path, image, jsonLd } = props;
  const url = SITE_ORIGIN + path;
  return (
    <MetaTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="HandCombos" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image ? <meta property="og:image" content={SITE_ORIGIN + image} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@handcombos" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </MetaTags>
  );
}
